import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import CategoryLabel from 'components/categoryLabel';
import CountDown from '../participates/countDown';

const AuctionsComp = ({ items }) => {
  const [key, setKey] = useState('home');
  const thousands = (num) => {
    return num.toString().split('').reverse().join('')
      .replace(/(?=\d*\.?)(\d{3})/g, '$1,')
      .split('')
      .reverse()
      .join('')
      .replace(/^[,]/, '');
  };
  return (
    <Container className="py-60">
      <Tabs
        id="controlled-tab-example"
        className="d-flex justify-content-center text-tangaroa"
        activeKey={key}
        onSelect={(k) => setKey(k)}>
        <Tab eventKey="home" title="Subastas Activas">
          <Row className="justify-content-center mt-40">
            <Col xs={10} lg={12}>
              <h2 className="text-center ft-24 f-600">¡Oferta con tus Puntos Aeroméxico Rewards y gana!</h2>
            </Col>
          </Row>
          {items.map((i) => (
            i.status === 'PUBLISHED' && (
              <div key={i.id}>
                <Row className="pt-30">
                  <Col lg={6} xl={8} className="">
                    <div className="carousel-img">
                      <img className="image" src={i.imageHome} alt="img" />
                      <CategoryLabel
                        category={i.categoria}
                        page="auctions" />
                    </div>
                  </Col>
                  <Col lg={6} xl={4}>
                    <div className="bg-alabaster p-3 text-tangaroa">
                      <h2 className="text-tangaroa f-600">
                        {i.title}
                      </h2>
                      <p>
                        {i.smallDescription}
                      </p>
                      <p className="font-weight-bold">Finaliza en</p>
                      <CountDown
                        size="middle"
                        closeDate={i.closeDate}
                        todayDate={i.serverDate} />
                      <h4 className="text-dark-blue mt-15 ml-2">
                        <i className="fas fa-coins mr-2" />
                        { `Oferta inicial: ${thousands(i.initialOffer)} Puntos Aeroméxico Rewards` }
                      </h4>
                      <Link to={`/subastas/${i.urlName}/${i.id}`} className="btn btn-primary mt-15 mb-2 image f-600">
                        Ver detalles
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            )))}
        </Tab>
        <Tab eventKey="profile" title="Próximas Subastas">
          <Row className="justify-content-center mt-40">
            <Col xs={10} lg={12}>
              <h2 className="text-center ft-24 f-600">¡Están por venir increíbles Subastas Aeroméxico Rewards!</h2>
            </Col>
          </Row>
          {items.map((i) => (
            i.status === 'COMING_SOON' && (
              <div key={i.id}>
                <Row className="pt-30">
                  <Col lg={6} xl={8}>
                    <div className="carousel-img">
                      <img className="image" src={i.imageHome} alt="img" />
                    </div>
                  </Col>
                  <Col lg={6} xl={4}>
                    <div className="bg-alabaster p-3 text-tangaroa">
                      <h2 className="text-tangaroa f-600">
                        {i.title}
                      </h2>
                      <p className="text-tangaroa">
                        {i.smallDescription}
                      </p>
                      <p className="font-weight-bold text-tangaroa">Inicia en</p>
                      <CountDown
                        size="middle"
                        closeDate={i.startDate}
                        todayDate={i.serverDate} />
                      <h4 className="text-dark-blue mt-15 ml-2">
                        <i className="fas fa-coins mr-2" />
                        { `Oferta inicial: ${thousands(i.initialOffer)} Puntos Aeroméxico Rewards` }
                      </h4>
                      <Link to={`/subastas/${i.urlName}/${i.id}`} className="btn btn-primary mt-15 mb-2 image f-600">
                        Ver detalles
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            )
          ))}
        </Tab>
      </Tabs>
    </Container>
  );
};

AuctionsComp.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    smallDescription: PropTypes.string.isRequired,
    imageHome: PropTypes.string.isRequired,
    initialOffer: PropTypes.number.isRequired,
    closeDate: PropTypes.string.isRequired,
    serverDate: PropTypes.string.isRequired,
    categoria: PropTypes.shape({
      title: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      iconUrl: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};

export default AuctionsComp;
